module.exports = __webpack_public_path__ + "img/globe-lines-grey.f3a5b4c5.svg";